module.exports = __webpack_public_path__ + "img/085.b7966ad3.png";